<template>
	<div class="pui-form">
		<mtipoimplicado-modals :modelName="modelName"></mtipoimplicado-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtipoimplicado-form-header
				:modelPk="modelPk"
			></mtipoimplicado-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPOIMPLICADO -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtipoimplicado-mtipoimplicado`"
									v-model="model.idtipoimplicado"
									:label="$t('mtipoimplicado.idtipoimplicado')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODTIPOIMPLICADO -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codtipoimplicado-mtipoimplicado`"
									v-model="model.codtipoimplicado"
									:label="$t('mtipoimplicado.codtipoimplicado')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mtipoimplicado`"
									v-model="model.name"
									:label="$t('mtipoimplicado.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="100"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtipoimplicado`"
									v-model="model.fecbaja"
									:label="$t('mtipoimplicado.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtipoimplicadoActions from './MtipoimplicadoActions';
import mtipoimplicadoModals from './MtipoimplicadoModals.vue';

export default {
	name: 'mtipoimplicado-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtipoimplicado-modals': mtipoimplicadoModals
	},
	data() {
		return {
			modelName: 'mtipoimplicado',
			actions: mtipoimplicadoActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtipoimplicado');
		}
	},
	created() {}
};
</script>
